<div class="col-12 p-4">
  <ul class="rounded list-unstyled" [ngStyle]="{'color': menu.colorText, 'border-color': menu.colorText}">
    <li *ngFor="let item of section.items" class="p-2">
      <div class="row align-items-center">
        <div class="col-12 text-left {{menu.fontHeader}}">
          <!-- Label de recomendado -->
          <app-recommend *ngIf="item.home" [menu]="menu"></app-recommend>
          <div translate="no">
            <ng-container *ngIf="!section.upperCaseName">
              {{ item.name | firstuppercase }}
            </ng-container>
            <ng-container *ngIf="section.upperCaseName">
              {{ item.name | uppercase }}
            </ng-container>
          </div>
        </div>
      </div>
      <div class="row" [ngClass]="{'w-100': menu.shape === 'scroll'}">
        <!-- Descripcion en espanol -->
        <p class="meal-desc {{menu.fontText}}" *ngIf="language === 'ES'" [innerHTML]="descriptionParser.getParsedDescription(item, 'ES')"></p>
        <!-- Descripcion en ingles -->
        <p class="meal-desc {{menu.fontText}}" *ngIf="language === 'EN'" [innerHTML]="descriptionParser.getParsedDescription(item, 'EN')"></p>
      </div>
    </li>
  </ul>
</div>